import { useCallback, useEffect, useState } from "react";

const SECTION_HEADER_BASE_CLASS =
  "tw-bg-secondary/50 tw-py-3.5 tw-px-3.5 tw-rounded-t-lg";

export const useCultivarSectionAccordion = (
  sectionsDisabled = false,
  initialOpen = false,
  hasError = false,
  openWhenEnabled = false
) => {
  const [accordionEnabled, setAccordionEnabled] = useState(
    initialOpen || (openWhenEnabled && !sectionsDisabled)
  );

  useEffect(() => {
    if (sectionsDisabled) {
      setAccordionEnabled(false);
    } else if (openWhenEnabled) {
      setAccordionEnabled(true);
    }
  }, [sectionsDisabled, openWhenEnabled]);

  // Collapsing the section while it has a validation error hides that error from view
  const toggleAccordion = useCallback(() => {
    if (sectionsDisabled) {
      return;
    }

    setAccordionEnabled(prev => (prev && hasError ? prev : !prev));
  }, [sectionsDisabled, hasError]);

  const headerClassName = sectionsDisabled
    ? `${SECTION_HEADER_BASE_CLASS} tw-opacity-50 tw-cursor-not-allowed`
    : `${SECTION_HEADER_BASE_CLASS} tw-cursor-pointer`;

  return {
    accordionEnabled,
    toggleAccordion,
    headerClassName
  };
};
